const { createContext } = require("react");


export const UnicommerseProps=createContext([]);